import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import fetch from '../../utils/fetch';
import Loading from '../../components/Loading';
import icons from '../../utils/icons.json';
import _ from 'lodash';
import ProductView from './ProductView';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import ProductSlider from './ProductSlider';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import { addRecentlyViewed } from '../../store/recentlyViewed';
import { useDispatch, useSelector } from 'react-redux';
import { setAlert } from '../../store/alert';
import Productratings from './productratings';
import { setFavicon } from '../../utils/functions';

function ProductPage() {
	useDocumentTitle('View Product');

	const dispatch = useDispatch();
	const navigate = useNavigate()
	const location = useLocation()
	const itemURL = location.pathname.split("/")[2];


	const recentlyViewed = useSelector((state) => state.recentlyViewed.data);
	const webSettings = useSelector((state) => state.webSettings.data);

	const { code } = useParams();
	const [product, setproduct] = useState('');
	const [similarProducts, setSimilarProducts] = useState([]);
	const [similarProductsLoading, setSimilarProductsLoading] = useState(true);
	const [loading, setloading] = useState(false);

	//feedbacks to display
	const [action, setaction] = useState('minimal');

	useEffect(() => {
		window.scroll({ top: 0 });
		fetchsingleproduct()
		//console.log(product);
	}, [itemURL]);



	const fetchsingleproduct = () => {
		setloading(true);
		fetch
			.get('item-details', { item_url: itemURL })
			.then((res) => {
				setloading(false)
				if (res.data) {
					const temproduct = res.data
					setproduct(temproduct)
					fetchSimilarProducts(temproduct.item_code);
					window.scroll({ top: 0, behavior: 'smooth' });
					dispatch(addRecentlyViewed(temproduct));

					setFavicon(temproduct.src[0])
					document.title = temproduct.item_name
					document.querySelector('meta[name="description"]').setAttribute('content', `${temproduct.item_name},price: ${temproduct.price}`);
				} else {
					dispatch(setAlert({ type: 'error', message: 'Error loading product details!! ' }));
				}

			})
			.catch((err) => {
				setloading(false)
				dispatch(setAlert({ type: 'error', message: 'Error loading product details!! ' + err.message }));
			});
	}

	function fetchSimilarProducts(item_code) {
		fetch
			.get('getSimilarProducts', { item_code: item_code })
			.then((res) => {
				setSimilarProducts(res.list);
				setSimilarProductsLoading(false);
			})
			.catch((err) => {
				dispatch(setAlert({ type: 'error', message: 'Error loading similar products!! ' + err.message }));
				setSimilarProductsLoading(false);
			});
	}


	return (
		<div className="main-body product-page">
			{product && <ProductView product={product} />}
			<div className="sections">
				<section className="title">
					<h3>Product Details</h3>
				</section>
				<div className="body" style={{ padding: '10px' }}>
					<h3>{product?.item_name}</h3>
					<p className="sp-top">
						Item Price: {webSettings.CURRENCY} {parseFloat(product.price)?.toFixed(2)}
					</p>
				</div>
			</div>
			<div className="sections" >
				<section className="title">
					<h3>Customer Feedback</h3>
					<div style={{ cursor: "pointer" }} onClick={() => setaction(action === 'all' ? 'minimal' : "all")} className="link-btn" dangerouslySetInnerHTML={{ __html: action === 'all' ? 'Show Less ' : 'View All' + icons.angle_right }} />
				</section>
				<div>
					{product && <Productratings action={action} product={product} />}
				</div>
			</div>
			<div className="similar-products sections">
				<h2 className="title">Related Products</h2>
				{similarProductsLoading && <Loading />}
				{similarProducts.length > 0 && <ProductSlider data={similarProducts} />}
				{!similarProductsLoading && similarProducts.length == 0 && <section style={{ padding: '10px' }}>We did not find any match for the product you selected</section>}
			</div>
			{/* <div className="banner" onClick={() => navigate('/products-and-services')} style={{ backgroundImage: `url(${banner_2})` }}></div> */}
			{recentlyViewed && recentlyViewed.length > 0 && (
				<div className="sections">
					<section className="title">
						<h3>Recently Viewed</h3>
					</section>
					{<ProductSlider data={recentlyViewed} />}
				</div>
			)}
		</div>
	);
}

export default React.memo(ProductPage);
